import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { connect } from 'react-redux';
import { generateActionCreators, mergeProps } from '../utils/connectors';
import _ from 'lodash';
import createResolver from '../utils/memoize-resolver';
/**
 * Maps a models state to props
 * @param  {Object} model
 * @param  {Object} state
 * @param  {Object} props
 * @return {Function}
 */

export function mapState(model, state, props) {
  return model.selectors(state, props);
}
/**
 * Map a models action dispatchers to props
 * @param  {Object} model
 * @param  {Function} dispatch
 * @return {Function}
 */

function _mapDispatch(model, dispatch) {
  return generateActionCreators(model)(dispatch);
}

export var mapDispatch = _.memoize(_mapDispatch, function (model) {
  return model.modelName;
});
/**
 * Decorator for React components mapping state and dispatchers
 * to props considering possible namespace (fallback the model name)
 * and deep merging the props before passing them down to the component
 * @param  {Object} model
 * @param  {string} namespace
 * @return {Function} React-redux connect abstraction
 */

export function withModel(model, namespace) {
  var NAME = namespace || model.modelName;

  var mapStateToProps = function mapStateToProps(state, props) {
    return _defineProperty({}, NAME, mapState(model, state, props));
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return _defineProperty({}, NAME, mapDispatch(model, dispatch));
  }; // HACK: This is a temporary workaround. The memoization that uses a key
  // resolver that plucks the specific piece of state using stateProps[NAME]
  // should happen in `modules/model-generator/src/utils/models.js`, but the
  // `create` function in that file has insufficient information to pluck the
  // state for entities - e.g. `entities.fooEntity`.
  //
  // Ideally, the memoize for the state should be moved into `create` and the
  // only memoize needed here should be for the merge.
  //
  // This workaround will ensure that models won't re-render when unrelated
  // state changed, but until the pucking resolver is moved into `create`
  // entities and value lists will still re-render.


  var mergeStateWithProps = function mergeStateWithProps(state, dispatchProps, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), dispatchProps, ownProps, NAME);
  };

  var memMergeStateWithProps = _.memoize(mergeStateWithProps, createResolver(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3),
        stateProps = _ref4[0],
        dispatchProps = _ref4[1],
        ownProps = _ref4[2];

    return [stateProps[NAME], dispatchProps, ownProps];
  }));

  return connect(function (state) {
    return state;
  }, // HACK: Pass the state to be mapped within mergeStateWithProps.
  mapDispatchToProps, memMergeStateWithProps);
}